module.exports = __webpack_public_path__ + "static/media/logo.bdfdd918.svg";